module.exports = __webpack_public_path__ + "img/ico_chev_left--orange.0c118e87.svg";